<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">

		<div class="">
			<el-form inline ref="form" :model="searchform">

			
                        <el-form-item class="mb-0 mr-0">
                         <el-select v-model="searchform.value1" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
                           <el-option
                                      v-for="item in searchform.searchOptions1"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value">
                                    </el-option>
                          </el-select>
                    </el-form-item>


                    <el-form-item class="mb-0 mr-0">
                         <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
                    </el-form-item>
					<el-form-item class="mb-0 mr-0">
						 <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:120px;">
						   <el-option
								      v-for="item in searchform.searchOptions"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
						  </el-select>
					</el-form-item>


					
					<el-form-item  class="mb-0" style="margin-right:0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd"style="width:200px" >
						    </el-date-picker>
					</el-form-item>
                     <el-form-item class="mb-0 mr-0">
                        {{$t('msg.하위포함')}}<el-checkbox true-label="1" false-label="0" v-model="searchform.xia" style="margin-left:5px;"></el-checkbox>
                      </el-form-item>
					<el-form-item class="mb-0 mr-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
					</el-form-item>
			</el-form>
       
		
		</div>
   
	
	</div>
    <div class="d-flex mt-2">
        <div class=""><!--※ 정산금 = (베팅 - 당첨) x 루징% - 총롤링금, ※ 실지급금 = 정산금 - 하부정산금--></div>
        <div class="ml-auto" style=""></div>
    </div>
   

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')" @sort-change='tableSortChange'>
    
      <el-table-column
      type="index"
      width="50" align="center">
    </el-table-column>
     
     <el-table-column
        
       :label="$t('nav.아이디')" prop="mem_id" align="center">
        <template slot-scope="scope"><el-button type="text" @click="openModel(scope.row.mem_id)">{{ scope.row.mem_id}}</el-button type="text"></template>
      </el-table-column>

     <el-table-column
        
        label="TYPE" prop="type" align="center">
      </el-table-column>

      <el-table-column
        :label="$t('msg.충전')"
        prop="inm" align="center" >
        <template slot-scope="scope">{{ formatMoney(scope.row.tt1)}}</template>

      </el-table-column>
       <el-table-column
        :label="$t('msg.환전')"
        prop="outm" align="center" >
        <template slot-scope="scope">{{ formatMoney(scope.row.tt2)}}</template>

      </el-table-column>
 
     <el-table-column
        :label="$t('msg.베팅')"
        prop="loging" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.bet)}}</template>
      </el-table-column>
		
		 <el-table-column
         :label="$t('msg.당첨')"
         prop="win" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.win)}}</template>
      </el-table-column>
   
     <el-table-column
         :label="$t('msg.베팅당첨')"
        prop="win" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.betwin)}}</template>
      </el-table-column>


         <el-table-column
         :label="$t('msg.카슬파루징')"
         prop="pct" align="center">
        <template slot-scope="scope">{{scope.row.pct}}%</template>
      </el-table-column>

       <el-table-column
        :label="$t('msg.롤링')"
        prop="log" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.log)}}</template>
      </el-table-column>

       <el-table-column
        :label="$t('msg.하부롤링')"
         prop="xlog" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.xlog)}}</template>
      </el-table-column>
       <el-table-column
        :label="$t('msg.실지급금')"
        prop="money" align="center">
        <template slot-scope="scope"><el-button type="text" @click="rdpModel(scope)">{{ formatMoney(scope.row.money)}}</el-button></template>
      </el-table-column>
    </el-table>
     <div style="height: 100px;"></div>
                     
         <el-dialog
            :visible.sync="rdpDialog" :width="rdpw" class="rdp" :close-on-click-modal ="false">
            <div class="border-bottom py-3"><span class="text-danger"></span></div>
            <el-table
                :data="rdpIdData"
                style="width: 100%" v-loading="loading"  
                show-summary 
                :summary-method="getSummaries">
                <el-table-column
                  prop="mem_id"
                  :label="$t('nav.아이디')"
                   align="center">
                </el-table-column>

                <el-table-column
                  prop="mem_name"
                  :label="$t('msg.닉네임')"
                   align="center">
                </el-table-column>

                <el-table-column
                  prop="tt678"
                  :label="$t('msg.롤링')"
                  align="center">
                  <template slot-scope="scope">
                     <span class="text-primary" @click="moenyModel(scope,'')">{{formatMoney(scope.row.tt678)}}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="tt7"
                  :label="$t('msg.롤링카')"
                   align="center">
                  <template slot-scope="scope">
                     <span class="text-primary" @click="moenyModel(scope,'2')">{{formatMoney(scope.row.tt7)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="tt6"
                  :label="$t('msg.롤링슬')"
                   align="center">
                  <template slot-scope="scope">
                     <span class="text-primary" @click="moenyModel(scope,'1')">{{formatMoney(scope.row.tt6)}}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="tt8"
                  :label="$t('msg.롤링파')"
                  align="center">
                  <template slot-scope="scope">
                     <span class="text-primary" @click="moenyModel(scope,'3')">{{formatMoney(scope.row.tt8)}}</span>
                  </template>
                </el-table-column>

                 <el-table-column
                  prop="type"
                   :label="$t('tableText.타입')"
                  align="center">
                  <template slot-scope="scope">
                  {{typeObj[scope.row.type]}}
                  </template>
                </el-table-column>



                 <el-table-column
                  prop="a_code"
                  :label="$t('tableText.부본사총판매장')"
                  align="center" width="200">
                   <template slot-scope="scope">
                  {{ scope.row.a_code}}-{{ scope.row.b_code}}-{{ scope.row.c_code}}
                  </template>
                </el-table-column>
                
              

                 
                
              
              </el-table>
  
            <span slot="footer" class="dialog-footer">
              <el-button @click="rdpDialog = false">Close</el-button>
        
            </span>
          </el-dialog>
				
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
import layerNew from '../../components/common/layer-new.vue';
    export default {
     components: {
      layer,layerNew
    },
    	data(){
    		return{
             rdpTitle:'',
             rdpIdData:[],
            rdpw:'870px',
            rdpDialog:false,    
           order:'',
           total:0,
           prop:'',
          level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")          
            },
          domain:window.sessionStorage.getItem('domain'),
           sitetype:window.sessionStorage.getItem('sitetype'),
           bg:window.sessionStorage.getItem('bg'),
           userid:window.sessionStorage.getItem('userid'),
           aid:window.sessionStorage.getItem('admin_id'),
          formLoading:false,
          idDialogVisible: false,
    
    			options: [{
	              label:this.$i18n.t("msg.대기"),
	              value: '1',
	             
	            }, {
	              label: this.$i18n.t("msg.처리중"),
	               value: '2',
	              
	            }, {
	              label: this.$i18n.t("msg.완료"),
	               value: '3',
	             
	            }, {
	              label: this.$i18n.t("msg.취소"),
	               value: '4',
	             
	            }], 
    			searchform:{
                    xia:false,
    				keyword:'',
    				time:[],
    				searchOptions:[
              
    			
		          {
                   label:this.$i18n.t("msg.슬롯"),
                    value:'slot'
                },
                    {
                     label:this.$i18n.t("msg.카지노"),
                      value:'live'
                    },
                     {
                      label:this.$i18n.t("msg.파워볼"),
                    
                      value:'power'
                    },
                     {
                      label:this.$i18n.t("msg.전체"),
                      
                      value:''
                    },
        		       
		       

		        ],
		      
		        value:'',
                    searchOptions1:[
             
                     {
                      label:this.$i18n.t("nav.아이디"),
                      value:'mem_id'
                    }
  
                ],
               
                value1:'',



    			},
    			 pickerOptions: {
    			},
         shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
        

		    		 loading: false,

		    		 creatModel:false,
		    		 tableData: [],
             inm:'',
             outm:'',
			        
			        
			         
			 
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
    	
    	methods:{
            rdpModel(e){
               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

          this.rdpDialog = true
          this.loading = true
           let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/admin/losing_id?id='+e.row.mem_id+'&s_time='+s_time+'&e_time='+e_time;
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },  
            }).then((response) =>{ 
                     this.loading =false
                     console.log('rdpdata=',response.data.data)
                     this.rdpIdData =response.data.data
                     this.rdpTitle=response.data.s_time+"~"+response.data.e_time
                    
               
            }).catch((error) =>{
              
               this.$message.error(error);
               this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })

        },
              getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) { 
              sums[index] = '/'
              return
            }
            else if (index === 1) { 
              sums[index] = '/'
              return
            }
         if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }else if (index === 4) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }else if (index === 5) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index],1);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 6) { 
              sums[index] = '/'
              return
            } else if (index === 7) { 
              sums[index] = '/'
              return
            }
        });
        return sums;
      },
       
        tableSortChange(column) {
 
                     this.prop= column.prop
                     this.order= column.order
                     
                    this.getList()
                 },
        
      
         openModel(id){

          if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: '',
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: ['830px', '680px'],
             
             });
              return;
           }
           
          this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });
        },
    			 // 搜索事件
			searchEvent(){

            
    			this.getList();
    			
             

    		},
    		
			    
			     
    		getList(){

    		   

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/losing??xia='+this.searchform.xia+'&fit='+this.prop+'&order='+this.order+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value1+'='+this.searchform.keyword+'&type='+this.searchform.value;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                   console.log('data=',response.data.data)
                     let data = response.data.data
                     this.tableData =data
                     this.total = response.data.total
                  
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
               
            })
    		},
    		
    		
    		
    	
    		
    	}
  }
</script>

 <style scoped>
 .bg-danger{
 	background-color:#72e8ff!important
 }
.bg-primary{
	background-color:#9dcdff!important
}
.bg-yellow {
    background-color: #f3ff77!important;
}
/deep/ .el-select-dropdown__item.selected{
	color:#000
}
/deep/ .el-input__inner{
	background:transparent;
	border:1px solid #cfcfcf;
	border-radius:2px;
}
/deep/ .el-dialog__body{
	padding:10px 20px;
}
/deep/ .el-form-item {
	margin-bottom:10px;
}

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
</style>


// WEBPACK FOOTER //
// src/views/losinglist/list.vue